import { render, staticRenderFns } from "./leadsDashboardReferralSettings.vue?vue&type=template&id=f48feee8&scoped=true"
import script from "./leadsDashboardReferralSettings.vue?vue&type=script&lang=js"
export * from "./leadsDashboardReferralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48feee8",
  null
  
)

export default component.exports